/**
 * This module listen for one variable status set
 */

import { validator } from './schema';
import { executor } from './executor';

export default [validator, executor];
